<template>
  <!-- 确认订单头部 -->
  <div class="order-header">
    <van-nav-bar title="购买成功" left-arrow @click-left="onClickLeft">
      <template #left>
        <van-icon name="arrow-left" color="#666666" />
      </template>
    </van-nav-bar>
    <div class="success_img" :style="allData.weixin?'':'marginTop: 3.3333rem'">
      <img src="@/assets/paysuccess.png" alt />
    </div>
    <div v-if="allData.word" class="title_" style="margin: 10px auto;">{{ allData.word }}</div>
    <div v-if="allData.success_word" class="title_" v-html="allData.success_word"></div>
    <!-- {{ allData.success_word }} -->
    <div v-else class="title_info_text">恭喜你购买成功 你购买的服务已生效，快去开始学习吧</div>
    <!-- <button v-if="allData.weixincode"
      class="copy_wx"
      data-clipboard-action="copy"
      :data-clipboard-text="allData.weixincode"
      @click="copyWx"
    >复制老师微信</button> -->
    <button v-if="allData.url" class="copy_wx" @click="jumpPage(studyUrl)">立即学习</button>
    <!-- <div class="btn_bottom_text" v-if="allData.weixincode">点击按钮复制老师微信，打开微信添加</div> -->
    <img :src="allData.weixin" @touchstart="touchStart()" @touchend="touchEnd()" class="qrcode_success">
    <!-- <p v-if="allData.weixin" class="img_text">长按保存二维码图片</p> -->
    <!-- <p v-if="allData.weixin" class="img_text">{{ allData.footer_str }}</p> -->
    <div class="bottom_box">
      <div v-show="isNotApp" class="link_box">
        <div class="link_item" @click="jumpPage(decodeURIComponent(allData.source_url),1)" v-show="showBack">返回</div>
        <div class="line_" v-show="showBack"></div>
        <div class="link_item" v-show="showBack" @click="jumpPage(allData.domain)">去首页</div>
      </div>
      <!-- <div class="bottom_box_text">请您用手机号{{ allData.mobile }}登陆“{{ showAppName }}APP”使用</div> -->
    </div>
  </div>
</template>
<script>
import Clipboard from 'clipboard'
import { Toast } from 'vant'
import tool from '@/utils/tools.js'
import { Dialog } from 'vant'
import isWx from "@/utils/isWechat.js";
import { setSuccessForWx } from "@/api/ePayPro.js";
import { getAgencyAppList } from "@/api/bbsApi.js";

export default {
  data () {
    return {
      studyUrl: `${window.location.origin}/ucenter/index/my_curriculum`,
      isNotApp: true,
      showBack: false,
      allData: {},
      showAppName: '',
      isWeiXin: isWx
    }
  },
  computed: {
  },
  beforeCreate () {
    // document.querySelector('body').setAttribute('style', 'background-color:#f7f7f7')
  },
  mounted () {
    if (tool.isInApp()) {
      this.isNotApp = false
    }
    this.setSuccessForWxFun()
  },
  created () {
    // 获取机构app
    this.getAgencyAppList()

    this.allData = JSON.parse(this.$route.query.str)
    // this.allData = {
    //   'id': 7882300,
    //   'order_sn': 'j2023031454219',
    //   'isSuccess': 1,
    //   'mobile': '185****9276',
    //   'real_money': 36,
    //   'weixin': 'https:\/\/wework.qpic.cn\/wwpic\/643795_5d3PkUWOTV2whJX_1676614961\/0',
    //   'source_url': '',
    //   'word': '恭喜您，支付成功！',
    //   'weixinName': '社群微信',
    //   'domain': 'https:\/\/m.zhulong.com',
    //   'weixincode': null,
    //   'status': 1,
    //   'success_word': '微信扫码开通e会员所有特权<br/>大傻逼',
    //   'footer_str': '',
    //   'group_qrcode': '',
    //   'group_neednum': 0,
    //   'group_id': 0,
    //   'product_id': 65,
    //   'product_type': 1,
    //   'paysuccessurl': 'https:\/\/m.zhulong.com\/pay\/paySuccess?str=%7B%22id%22%3A7882300%2C%22order_sn%22%3A%22j2023031454219%22%2C%22isSuccess%22%3A1%2C%22mobile%22%3A%22185%2A%2A%2A%2A9276%22%2C%22real_money%22%3A36%2C%22weixin%22%3A%22https%3A%5C%2F%5C%2Fwework.qpic.cn%5C%2Fwwpic%5C%2F643795_5d3PkUWOTV2whJX_1676614961%5C%2F0%22%2C%22source_url%22%3A%22%22%2C%22word%22%3A%22%5Cu606d%5Cu559c%5Cu60a8%5Cuff0c%5Cu652f%5Cu4ed8%5Cu6210%5Cu529f%5Cuff01%22%2C%22weixinName%22%3A%22%5Cu793e%5Cu7fa4%5Cu5fae%5Cu4fe1%22%2C%22domain%22%3A%22https%3A%5C%2F%5C%2Fm.zhulong.com%22%2C%22weixincode%22%3Anull%2C%22status%22%3A1%2C%22success_word%22%3A%22%5Cu5fae%5Cu4fe1%5Cu626b%5Cu7801%5Cu5f00%5Cu901ae%5Cu4f1a%5Cu5458%5Cu6240%5Cu6709%5Cu7279%5Cu6743%22%2C%22footer_str%22%3A%22%22%2C%22group_qrcode%22%3A%22%22%2C%22group_neednum%22%3A0%2C%22group_id%22%3A0%2C%22product_id%22%3A65%2C%22product_type%22%3A1%7D',
    //   'url': '',
    //   'order_type': 1,
    //   'priduct_end_time': '2023-06-14'
    // }
    console.log(this.allData,' this.allData')
    if (this.allData.order_type == 1 || this.allData.source_url) { this.showBack = true }
  },

  methods: {

    setSuccessForWxFun () {
      setSuccessForWx({ order_sn: this.allData.order_sn }).then(res => {

      })
    },
    // 调起app 方法，app调起小程序
    callAppWeixinMiniprogram(){
      var qrcodeurl = this.allData.weixin || ''
      var title = this.allData.word || ''
      var detail = this.allData.success_word || ''
      const appid = 'gh_7df350421526'
      // 0：体验版 1：正式版
      const wxtype = 1
      var params_str = `qrcodeurl=${qrcodeurl}&title=${title}&detail=${detail}`
      var path = `/pages/qrCode/qrCode?${params_str}`
      path = encodeURIComponent(path)
      var url_str = `?url=${path}&wxtype=${wxtype}&appid=${appid}`
      if (tool.isInApp()) {
        if (tool.isInIosApp()) {
          window.webkit.messageHandlers.vue_unitOpenMinProgress.postMessage(url_str);
        } else {
          window.WebViewJavascriptBridge.callHandler(
            "vue_unitOpenMinProgress",
            url_str,
            function (responseData) {
              // android 返参数接受
            }
          );
        }
      }
    },
    // 返回
    onClickLeft () {
      // 处理APP
      if (tool.isInApp()) {
        if (tool.isInIosApp()) {
          window.webkit.messageHandlers.vue_backApp.postMessage("");
        } else {
          window.WebViewJavascriptBridge.callHandler(
            "vue_backApp",
            "",
            function (responseData) {
              // android 返参数接受
            }
          );
        }
      } else {
        // h5
        this.$router.go(-1);
      }
    },
    jumpPage (url, isBack = false) {
      if (isBack && !url) {
        //'order_type': 1, // 类型：Number  必有字段  备注：类型 1 E会员 2 vip 3课程
        window.location.href = '/ucenter/index/my_curriculum'
      } else {
        window.location.href = url

      }
    },
    copyWx () {
      const _this = this
      const clipboard = new Clipboard('.copy_wx')
      clipboard.on('success', function () {
        Toast.success('复制成功')
        console.log('copysuccess')
      })
      clipboard.on('error', function () {
        Dialog.alert({
          title: '提示',
          message: '当前环境暂不支持一键复制，请手动添加：' + _this.allData.weixincode
        }).then(() => {

        })
      })
    },

    // 获取机构的app
    getAgencyAppList() {
      getAgencyAppList().then(res => {
        console.log(res, 'res')
        if (res.errNo == 0) {
          let r = res.result ? res.result : []
          if (r && r.length > 0) {
            this.showAppName = r[0].name
          }
        }
      })
    },

  }
}
</script>
<style scoped lang='scss'>
.bottom_box {
  width: 100%;
  position: absolute;
  bottom: 40px;
  left: 0;
  .bottom_box_text {
    font-family: PingFangSC-Regular;
    font-size: 28px;
    color: #999999;
    letter-spacing: 0;
    text-align: center;
    margin: 40px 0;
  }
}
.link_box {
  display: flex;
  width: 60%;
  margin: 0 auto;
  justify-content: space-between;
  align-items: center;

  .link_item {
    font-family: PingFangSC-Regular;
    font-size: 30px;
    color: #ee2e2e;
    letter-spacing: 0.22px;
    text-align: center;
    width: 30%;
  }
  .line_ {
    background-color: #c1c1c1;
    width: 1px;
    height: 16px;
  }
}
.success_img {
  margin-top: 100px;
  img {
    display: block;
    margin: 0 auto;
    width: 320px;
  }
}
.title_ {
  font-family: PingFangSC-Medium;
  line-height: 52px;
  font-size: 38px;
  color: #222222;
  letter-spacing: 0;
  text-align: center;
}
.title_info_text {
  width: 70%;
  margin: 0 auto;
  font-family: PingFangSC-Regular;
  font-size: 30px;
  color: #222222;
  letter-spacing: 0;
  text-align: center;
}
.copy_wx {
  width: 388px;
  line-height: 72px;
  color: #fff;
  background-color: #ee2e2e;
  border-radius: 12px;
  font-size: 26px;
  display: block;
  margin: 30px auto;
}
.btn_bottom_text {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #666666;
  letter-spacing: 0;
  text-align: center;
}
.qrcode_success{
  display: block;
  width: 288px;
  margin: 60px auto 20px;
}
.img_text{
  width: 80%;
  margin: 0 auto;
  font-family: PingFangSC-Regular;
  font-size: 24px;
  color: #222222;
  letter-spacing: 0;
  text-align: center;
}
</style>
